import React, { Component } from "react";
import { resolveLocaleContext } from "../../../_utils/localeContext";
import "../Styles/NoMatch.css";

class NoMatch extends Component {
    render() {
        const locale = resolveLocaleContext({
            search: this.props.location ? this.props.location.search : "",
            store: this.props.store,
            language: this.props.language,
            country: this.props.country,
            storeList: null,
            countryList: null
        }).locale;

        return (
            <section className="fit layout vertical center-center page-not-found">
                <h2>404</h2>
                <h3>{locale.NOT_FOUND_PAGE.TITLE}</h3>
                <span className="thick-divider" />
                <p className="description">{locale.NOT_FOUND_PAGE.DESCRIPTION}</p>
                <p className="help-message">
                    {`${locale.NOT_FOUND_PAGE.HELP_MESSAGE} `}
                    <a href={locale.MISC.HELP_LINK} class="help-link">
                        {locale.MISC.HELP_LINK}
                    </a>
                </p>
            </section>
        );
    }
}

export default NoMatch;
